var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1071_2956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8424 20.8206H1.14235C0.517868 20.8206 0 20.3027 0 19.663V3.45681C0 2.83232 0.517868 2.31445 1.14235 2.31445H24.8424C25.4821 2.31445 26 2.83232 26 3.45681V19.663C26 20.3027 25.4821 20.8206 24.8424 20.8206ZM13.6626 19.1147H12.3222C12.1851 19.1147 12.0785 18.9928 12.0785 18.8558C12.0785 18.7187 12.1851 18.6121 12.3222 18.6121H13.6626C13.8149 18.6121 13.9215 18.7187 13.9215 18.8558C13.9215 18.9928 13.8149 19.1147 13.6626 19.1147ZM24.4769 16.9061H1.52314V4.47731C1.52314 4.12699 1.81254 3.83759 2.16286 3.83759H23.8371C24.1875 3.83759 24.4769 4.12699 24.4769 4.47731V16.9061ZM10.9818 23.4252C10.8448 23.4252 10.7229 23.3186 10.7229 23.1815V21.3232H15.2771V23.1815C15.2771 23.3186 15.1552 23.4252 15.0182 23.4252H10.9818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0479 23.6846H7.93428C7.66011 23.6846 7.43164 23.4561 7.43164 23.1819C7.43164 22.8925 7.66011 22.6641 7.93428 22.6641H18.0479C18.3373 22.6641 18.5658 22.8925 18.5658 23.1819C18.5658 23.4561 18.3373 23.6846 18.0479 23.6846Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1071_2956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.e1c75e75ed1f5fff6450df6d6875d3b8.svg";
export { ForwardRef as ReactComponent };